import {
  PLACEHOLDER_VISITOR_FLAG_KEY,
  PLACEHOLDER_VISITOR_REQUEST_KEY,
} from './placeholderVisitorKeys'

export interface PlaceholderVisitorPayload {
  visiting_team_id: string | null
  [key: string]: unknown
}

/**
 * The visiting-team half of a create/update game payload.
 *
 * Kept here so the form never spells a wire key: the flag and the name are
 * named once, in `placeholderVisitorKeys`, and a backend rename stays a
 * one-file change.
 *
 * The two are mutually exclusive by construction -- a placeholder game sends a
 * null team id, and an ordinary game sends a null name -- so a value the admin
 * stopped seeing can never ride along into the request.
 */
export const buildPlaceholderVisitorPayload = ({
  usePlaceholderVisitor,
  visitingTeamId,
  placeholderName,
}: {
  usePlaceholderVisitor: boolean
  visitingTeamId: string | null | undefined
  placeholderName: string | null | undefined
}): PlaceholderVisitorPayload => {
  if (usePlaceholderVisitor) {
    return {
      visiting_team_id: null,
      [PLACEHOLDER_VISITOR_FLAG_KEY]: true,
      [PLACEHOLDER_VISITOR_REQUEST_KEY]: (placeholderName ?? '').trim(),
    }
  }

  return {
    visiting_team_id: visitingTeamId ?? null,
    [PLACEHOLDER_VISITOR_FLAG_KEY]: false,
    [PLACEHOLDER_VISITOR_REQUEST_KEY]: null,
  }
}
